import React, { useEffect, useState } from 'react'
import { TableContainer, Table, TableHead, TableCell, TableRow, Paper, TableBody, TextField, Typography, CircularProgress, Box, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getBiocharVolumes, postBiocharMc } from '../../../../../actions/tigercat-burns/tigercat-actions';
import moment from 'moment';

const BiocharMcBins = ({ projectId }) => {
    const dispatch = useDispatch()
    const [biocharMcBinsState, setBiocharMcBinsState] = useState([])
    const biocharVolumes = useSelector(state => state.tigercatBurnsReducer.biocharVolumes.data)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        dispatch(getBiocharVolumes(projectId));
    }, [dispatch, projectId])

    useEffect(() => {
        const stateArray = biocharVolumes?.map((item) => ({
            id: item.id,
            rowId: item.id, // or uuid if needed
            date: item.created_at.split('T')[0],
            binUsed: item.bin_used_name,
            biocharVolume: item.biochar_volume,
            moistureContent: item.moisture_content,
            dryMatter: item.dry_matter,
            comment: item.comment === null ? '' : item.comment,
            dirty: false,
            disabled: item.moisture_content === null ? false : true,
        })) || [];
        setBiocharMcBinsState(stateArray);
    }, [biocharVolumes, projectId]);

    const handleInputChange = (e, rowId, field) => {
        setBiocharMcBinsState((prevState) =>
            prevState.map((item) =>
                item.rowId === rowId
                    ? { ...item, [field]: e.target.value, dirty: true }
                    : item
            )
        );
    };

    const handleSubmitData = async () => {
        try {
            setLoading(true);

            const validBiocharMcState = biocharMcBinsState.filter((i) => {
                if (!i.dirty) return false; // Only submit dirty rows

                // Your current check uses string 'null'. Here we handle real null/undefined/'' too:
                if (!i.moistureContent === '' || i.moistureContent == null) {
                    return false;
                }

                return true;
            });


            if (validBiocharMcState.length === 0) {
                console.log('No dirty/valid rows to submit');
                setLoading(false);
                return;
            }

            const formData = new FormData();
            formData.append('data', JSON.stringify(validBiocharMcState));

            await dispatch(postBiocharMc(projectId, formData, 'bins'))
            await dispatch(getBiocharVolumes(projectId));

        } catch (err) {
            console.error('Error submitting biochar MC data', err);
            // Optionally show a toast / alert here
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <h2>Biochar MC - Bins</h2>
            <TableContainer key={0} component={Paper} sx={{ height: 'auto' }}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell size="small" align="left">Date</TableCell>
                            <TableCell size="small" align="left">Bin Used</TableCell>
                            <TableCell size="small" align="left">Volume Biochar (m3)</TableCell>
                            <TableCell size="small" align="left">Moisture Content</TableCell>
                            <TableCell size="small" align="left">Dry Matter</TableCell>
                            <TableCell size="small" align="left">Comments</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {biocharMcBinsState?.map((data, index) => (
                            <TableRow key={index}>
                                <TableCell size="small" align="left">{moment(data.date).format('MM-DD-YY')}</TableCell>
                                <TableCell size="small" align="left">{data.binUsed}</TableCell>
                                <TableCell size="small" align="left">{data.biocharVolume}</TableCell>
                                <TableCell size="small" align="left">
                                    <TextField
                                        name='moistureContent'
                                        value={data.moistureContent === 'null' ? '' : data.moistureContent}
                                        onChange={(e) => handleInputChange(e, data.rowId, 'moistureContent')}
                                        type="text"
                                        disabled={data.disabled}
                                    />
                                </TableCell>
                                <TableCell size="small" align="left">
                                    {data.dryMatter === null ? <Typography sx={{ color: 'darkorange' }}>Undetermined</Typography> : data.dryMatter}
                                </TableCell>
                                <TableCell size="small" align="left">
                                    <TextField
                                        name='comment'
                                        value={data.comment}
                                        onChange={(e) => handleInputChange(e, data.rowId, 'comment')}
                                        type="text"
                                        disabled={data.disabled}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Box sx={{ position: 'relative', mb: 10 }}>
                {loading ?
                    <CircularProgress sx={{ position: 'absolute', left: '125px', top: '12px' }} />
                    : <Button variant='contained' sx={{ height: 'auto', mt: 2 }} onClick={handleSubmitData}>Submit Data</Button>
                }
            </Box>
        </>
    )
}

export default BiocharMcBins